import React from 'react';
import PrimaryButton from '../common/PrimaryButton';
import PrimarySectionLayout from '../layout/PrimarySectionLayout';
import CourseCard from '../common/pagecomponents/CourseCard';
import { graphql, useStaticQuery } from 'gatsby';
import AniLink from 'gatsby-plugin-transition-link/AniLink';

const ChooseYourProgram = () => {
    const data = useStaticQuery(query);

    const {
        allStrapiCourse: { nodes: Courses },
        allStrapiHomeChooseYourProgram: { nodes: HomeChooseYourProgram },
    } = data;

    const { home_chooseYourProgram_heading, home_chooseYourProgram_button } =
        HomeChooseYourProgram[0];

    return (
        <>
            <PrimarySectionLayout
                PrimarySectionHeading={home_chooseYourProgram_heading}
            >
                <div className="choose_your_program_card_wrapper">
                    {Courses.map((courseItem) => (
                        <CourseCard
                            CourseName={courseItem.Course_Card.course_type}
                            CourseDescription={
                                courseItem.Course_Card.course_description
                            }
                            CourseImage={
                                courseItem.Course_Card.course_image.url
                            }
                            CourseUrl={courseItem.Course_Card.course_url}
                        />
                    ))}
                </div>
                <AniLink
                    fade
                    to={home_chooseYourProgram_button.button_redirection}
                >
                    <PrimaryButton
                        ButtonText={home_chooseYourProgram_button.button_text}
                        MaxWidth={13.9375}
                    />
                </AniLink>
            </PrimarySectionLayout>
        </>
    );
};

export const query = graphql`
    {
        allStrapiCourse(
            filter: { Course_Card: { published_homepage: { eq: true } } }
        ) {
            nodes {
                Course_Card {
                    id
                    course_type
                    course_description
                    course_image {
                        url
                    }
                    course_url
                }
            }
        }
        allStrapiHomeChooseYourProgram {
            nodes {
                home_chooseYourProgram_heading
                home_chooseYourProgram_button {
                    button_text
                    button_redirection
                }
            }
        }
    }
`;

export default ChooseYourProgram;
